<template>
  <b-modal
    :visible="show"
    title="Incluir item"
    @hide="$emit('close')"
    centered
    hide-footer
  >
    <b-form @submit.prevent="handleSubmit">

      <b-form-group label="Tipo">
        <b-form-select v-model="form.type" :options="typeOptions" required />
      </b-form-group>

      <b-form-group label="Documento">
        <b-form-input
        v-model="form.document"
        v-mask="form.type === 'PF' ? '###.###.###-##' : '##.###.###/####-##'"
        placeholder="Digite o documento"
        required
        />
      </b-form-group>

      <b-form-group label="Nome / Razão Social">
        <b-form-input v-model="form.name" required  placeholder="Digite o nome/razão social"/>
      </b-form-group>

      <b-form-group label="Motivo">
        <b-form-select v-model="form.reason" :options="reasonOptions" required />

        <b-form-input
          v-if="isOtherSelected"
          v-model="form.customReason"
          placeholder="Descreva o motivo"
          class="mt-2"
          required
        />
      </b-form-group>

      <b-form-group label="Fonte">
        <b-form-select v-model="form.source" :options="sourceOptions" required />
      </b-form-group>

      <div class="d-flex justify-content-end mt-3">
        <b-button variant="secondary" class="mr-2" @click="$emit('close')">
          Cancelar
        </b-button>

        <b-button variant="primary" type="submit">
          Incluir
        </b-button>
      </div>

    </b-form>
  </b-modal>
</template>

<script>
import BlacklistService from '@/service/blacklist'
import {
  BModal,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BButton
} from 'bootstrap-vue'

export default {
  components: {
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton
  },

  props: {
    show: Boolean
  },

  data() {
    return {
      reasons: [], 
      form: {
        type: '',
        document: '',
        name: '',
        reason: '',
        customReason: '',
        source: ''
      },

      typeOptions: [
        { value: '', text: 'Selecione' },
        { value: 'PF', text: 'Pessoa Física' },
        { value: 'PJ', text: 'Pessoa Jurídica' }
      ],


      sourceOptions: [
        { value: '', text: 'Selecione' },
        { value: 'soulpay', text: 'SoulPay' },
        { value: 'viainvest', text: 'ViaInvest' }
      ]
    }
  },

  watch: {
    show(val) {
      if (val) {
        this.fetchReasons()
      }
    }
  },

  computed: {
    reasonOptions() {
      return [
        { value: '', text: 'Selecione' },
        ...this.reasons.map(r => ({
          value: r,
          text: r
        })),
      ]
    },
    isOtherSelected() {
      return this.form.reason?.includes('OUTROS')
    }
},
  methods: {
    handleSubmit() {
      if (!this.isValid()) return

     const payload = {
      ...this.form,
      reason: this.isOtherSelected
        ? this.form.customReason
        : this.form.reason
    }

      this.$emit('submit', payload)
      this.resetForm()
      this.$emit('close')
    },

    async fetchReasons() {
      try {
        const response = await BlacklistService.getReasons()

        this.reasons = response.data || []

      } catch (error) {
        console.error('Erro ao buscar motivos:', error)
      }
    },

    isValid() {
      return (
        this.form.type &&
        this.form.document &&
        this.form.name &&
        this.form.reason &&
        (this.form.reason !== 'Outro' || this.form.customReason) &&
        this.form.source
      )
    },

    resetForm() {
      this.form = {
        type: '',
        document: '',
        name: '',
        reason: '',
        customReason: '',
        source: ''
      }
    }
  }
}
</script>